import { put, race, take, select } from 'redux-saga/effects'
import { SUCCESS, FAILED } from 'crom-api-constants'
import { Map } from 'immutable'
import _ from 'lodash'

import { success, error } from '../../../../../services/toastr'

import { insertMemberToGroupRequest } from '../../../../../scenes/Gnosus/components/GroupStack/actions'
import { INSERT_MEMBER_TO_GROUP_REQUEST } from '../../../../../scenes/Gnosus/components/GroupStack/constants'

import { LOCALE_PREFIX } from '../constants'
import { sessionIdSelector } from '../selectors'
import { manageGroupsDialogSetRowLoading } from '../actions'
import { reloadRows, getIsPresentInGroups } from '../helpers'

const INSERT_MEMBER_TO_GROUP_REQUEST_SUCCESS = (groupId) => `${INSERT_MEMBER_TO_GROUP_REQUEST(groupId)}_${SUCCESS}`
const INSERT_MEMBER_TO_GROUP_REQUEST_FAILED = (groupId) => `${INSERT_MEMBER_TO_GROUP_REQUEST(groupId)}_${FAILED}`

export default function* dialogImportSingleCallSaga(action) {
    const groupId = _.get(action, 'data.groupId', null)
    const entities = _.get(action, 'data.entities', []) // Array of single entity
    const index = _.get(action, 'data.index', null)
    const entId = _.get(entities, '[0]', Map()).get('id', null)
    const sid = yield select(sessionIdSelector)

    if (!groupId || !entities || entities.length !== 1 || !entId) {
        error({ id: `${LOCALE_PREFIX}.importFailedMsg` })
        return null
    }

    yield put(manageGroupsDialogSetRowLoading(index, true))

    // Has to be request, not the action from group stack because it opens group when importing
    yield put(insertMemberToGroupRequest(groupId, entId, sid))

    const result = yield race({
        success: take(INSERT_MEMBER_TO_GROUP_REQUEST_SUCCESS(groupId)),
        failed: take(INSERT_MEMBER_TO_GROUP_REQUEST_FAILED(groupId)),
    })

    if (result.success) {
        // Reload groups and rows
        // (we have to get in which groups an entity is present to refresh the buttons in the dialog group list)
        const isPresentInGroups = yield getIsPresentInGroups(entId)
        success({ id: `${LOCALE_PREFIX}.importSingleSuccessMsg` })
        yield reloadRows(isPresentInGroups)
    } else {
        error({ id: `${LOCALE_PREFIX}.importFailedMsg` })
    }

    yield put(manageGroupsDialogSetRowLoading(index, false))

    return null
}
